// extracted by mini-css-extract-plugin
export default {"container":"Statics_container__jo36h","border":"Statics_border__RtkBw"};